import { B2bUserType } from 'shared-types/user';

import { UserState } from './types';

export const userInitialState: UserState = {
  userUuid: null,
  userType: B2bUserType.TSL,
};
